import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Eye, AlertTriangle } from 'lucide-react';
export function SecuritySection() {
  const features = [{
    icon: <ShieldCheck className="w-6 h-6 text-green-500" data-id="element-301" />,
    title: 'Cumplimiento PCI DSS',
    description: 'Cumplimos con los más altos estándares de seguridad de la industria de tarjetas de pago.'
  }, {
    icon: <Lock className="w-6 h-6 text-blue-500" data-id="element-302" />,
    title: 'Encriptación End-to-End',
    description: 'Los datos sensibles son encriptados desde el punto de captura hasta nuestro bóveda segura.'
  }, {
    icon: <Eye className="w-6 h-6 text-purple-500" data-id="element-303" />,
    title: 'Monitoreo 24/7',
    description: 'Sistemas automatizados y equipo humano vigilando la red en todo momento.'
  }, {
    icon: <AlertTriangle className="w-6 h-6 text-orange-500" data-id="element-304" />,
    title: 'Prevención de Fraude AI',
    description: 'Motor de machine learning que detecta y bloquea transacciones sospechosas en milisegundos.'
  }];
  return <section id="seguridad" className="py-24 bg-white" data-id="element-305">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-306">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-307">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-2 lg:order-1" data-id="element-308">
            <div className="bg-gray-900 rounded-3xl p-8 md:p-12 text-white relative overflow-hidden" data-id="element-309">
              {/* Decorative background */}
              <div className="absolute top-0 right-0 -mt-16 -mr-16 w-64 h-64 bg-zumpago-red/20 rounded-full blur-3xl" data-id="element-310"></div>
              <div className="absolute bottom-0 left-0 -mb-16 -ml-16 w-64 h-64 bg-blue-500/20 rounded-full blur-3xl" data-id="element-311"></div>

              <div className="relative z-10" data-id="element-312">
                <ShieldCheck className="w-16 h-16 text-zumpago-red mb-8" data-id="element-313" />
                <h3 className="text-3xl font-bold mb-4" data-id="element-314">
                  Tu seguridad es nuestra prioridad absoluta
                </h3>
                <p className="text-gray-400 mb-10 text-lg" data-id="element-315">
                  Protegemos cada transacción, cada dato y cada cliente con
                  tecnología basada en los más altos estándares internacionales.
                </p>

                <div className="space-y-6" data-id="element-316">
                  {features.map((feature, index) => <div key={index} className="flex gap-4" data-id="element-317">
                      <div className="mt-1 bg-gray-800 p-2 rounded-lg h-fit" data-id="element-318">
                        {feature.icon}
                      </div>
                      <div data-id="element-319">
                        <h4 className="font-semibold text-lg" data-id="element-320">
                          {feature.title}
                        </h4>
                        <p className="text-gray-400 text-sm" data-id="element-321">
                          {feature.description}
                        </p>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-1 lg:order-2" data-id="element-322">
            <h2 className="text-lg font-bold text-zumpago-red tracking-wider uppercase mb-3" data-id="element-323">
              Seguridad y Confianza
            </h2>
            <h3 className="text-4xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-324">
              Protección total contra el fraude
            </h3>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-325">
              Sabemos que la confianza es la base de cualquier negocio
              financiero. Por eso, hemos construido una infraestructura de
              seguridad impenetrable que protege tanto a tu empresa como a tus
              clientes.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-326">
              Nuestro motor antifraude analiza más de 200 variables por
              transacción en tiempo real, maximizando la aprobación de pagos
              legítimos y bloqueando intentos maliciosos antes de que ocurran.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}